module.exports = __webpack_public_path__ + "static/media/llanos.13b48ad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/llanos.png
// module id = 1156
// module chunks = 0